import VideoPlayerModal from './video-player-modal'

export default VideoPlayerModal
